/* ===== YESUGOD theme ===== */
(function(){
  const routes = {cart_add:'/cart/add.js',cart_change:'/cart/change.js',cart:'/cart.js'};

  (function(){
    const header = document.querySelector('.site-header');
    if(!header) return;
    function setH(){ document.documentElement.style.setProperty('--header-h', header.offsetHeight + 'px'); }
    setH();
    addEventListener('resize', setH);
    if(window.ResizeObserver){ new ResizeObserver(setH).observe(header); }
    if(document.fonts && document.fonts.ready){ document.fonts.ready.then(setH); }
  })();

  const io = new IntersectionObserver(es=>es.forEach(e=>{if(e.isIntersecting){e.target.classList.add('in');io.unobserve(e.target);}}),{threshold:.15});
  function bindReveals(root){ (root||document).querySelectorAll('.reveal:not(.in)').forEach(el=>io.observe(el)); }
  bindReveals();

  let toastEl;
  function toast(msg){
    if(!toastEl){toastEl=document.createElement('div');toastEl.className='yg-toast';document.body.appendChild(toastEl);}
    toastEl.textContent=msg;toastEl.classList.add('show');
    clearTimeout(toastEl._t);toastEl._t=setTimeout(()=>toastEl.classList.remove('show'),1800);
  }

  const drawer = document.querySelector('.cart-drawer');
  function openCart(){ if(drawer){drawer.classList.add('open');document.body.classList.add('cart-drawer-open');document.body.style.overflow='hidden';} }
  function closeCart(){ if(drawer){drawer.classList.remove('open');document.body.classList.remove('cart-drawer-open');document.body.style.overflow='';} }
  if(drawer){
    drawer.querySelector('.scrim')?.addEventListener('click',closeCart);
    drawer.querySelector('.cd-close')?.addEventListener('click',closeCart);
    addEventListener('keydown',e=>{if(e.key==='Escape')closeCart();});
  }
  document.querySelectorAll('[data-cart-open]').forEach(b=>b.addEventListener('click',e=>{e.preventDefault();refreshCart();openCart();}));

  function money(cents){
    return '$' + (cents/100).toFixed(2).replace(/\.00$/,'');
  }
  async function refreshCart(){
    try{
      const r = await fetch(routes.cart+'?t='+Date.now()); const cart = await r.json();
      renderCart(cart);
    }catch(e){}
  }
  function renderCart(cart){
    document.querySelectorAll('[data-cart-count]').forEach(c=>{ c.textContent='('+cart.item_count+')'; });
    document.querySelectorAll('[data-cart-badge]').forEach(b=>{ b.textContent=cart.item_count; if(cart.item_count>0){ b.setAttribute('data-on',''); } else { b.removeAttribute('data-on'); } });
    const items=drawer && drawer.querySelector('.cd-items');
    const sub=drawer && drawer.querySelector('[data-cart-subtotal]');
    if(!items) return;
    if(!cart.items || !cart.items.length){
      items.innerHTML='<div class="cd-empty">Your bag is empty</div>';
      if(sub) sub.textContent='';
      return;
    }
    items.innerHTML = cart.items.map(it=>`
      <div class="cd-item" data-key="${it.key}">
        <a class="ci-img" href="${it.url}" aria-label="${(it.product_title||'').replace(/"/g,'&quot;')}"><img src="${it.image ? it.image.replace(/(\.[a-z]+)(\?|$)/,'_120x150$1$2') : ''}" alt=""></a>
        <div class="ci-info">
          <a class="ci-n" href="${it.url}">${it.product_title}</a>
          <div class="ci-o">${(it.options_with_values||[]).map(o=>o.value).join(' · ')}</div>
          <div class="ci-b"><span>${money(it.final_line_price)}</span></div>
        </div>
        <button class="ci-rm" type="button" data-key="${it.key}" aria-label="Remove item"></button>
      </div>`).join('');
    if(sub) sub.textContent = money(cart.items_subtotal_price);
    items.querySelectorAll('.ci-rm').forEach(b=>b.addEventListener('click',async()=>{
      await fetch(routes.cart_change,{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({id:b.dataset.key,quantity:0})});
      refreshCart();
    }));
  }

  async function addToCart(id, qty){
    if(id == null || id === '' || id === '0'){ toast('Select an option'); return false; }
    try{
      const r = await fetch(routes.cart_add,{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items:[{id:id,quantity:qty||1}]})});
      if(!r.ok){ const err=await r.json().catch(()=>({})); toast(err.description||err.message||'Could not add to bag'); return false; }
      await refreshCart(); return true;
    }catch(e){ toast('Could not add to bag'); return false; }
  }
  window.YG = window.YG || {}; window.YG.addToCart = addToCart; window.YG.openCart = openCart; window.YG.toast = toast; window.YG.bindReveals = bindReveals;

  var COLORMAP = {black:'#26251f',jet:'#1c1b17',white:'#f4f1ea',ivory:'#f2ebdd',cream:'#e8e0d0',beige:'#d9c7a8',tan:'#c9a97e',camel:'#b78b56',khaki:'#b7a878',brown:'#7a4a3a',chocolate:'#4b2e22',mocha:'#6b4b3a',red:'#9a2f2a',crimson:'#8a2320',burgundy:'#5c1f26',wine:'#5c1f26',maroon:'#5c1f26',pink:'#e6b9c4',rose:'#d98a9a',blush:'#e8c9cf',fuchsia:'#c14a86',coral:'#e08a6f',orange:'#c8642c',rust:'#a5502e',terracotta:'#b5623f',yellow:'#d9b44a',mustard:'#c99a3a',gold:'#b9985a',green:'#3f5340',olive:'#6b6a3c',emerald:'#1f5c46',forest:'#243b2b',sage:'#a8b09a',mint:'#bcd6c2',teal:'#2f6d6a',wintergreen:'#4f7a68',blue:'#2f4a6d',navy:'#1e2a44',cobalt:'#2a4bd0',denim:'#41597a',sky:'#a8c3d9',baby:'#bcd4e6',cerulean:'#2f6f91',aqua:'#4fa8a0',purple:'#5b3f6d',violet:'#6a4a8c',lavender:'#c3b1d6',plum:'#5c3550',grey:'#8f8c85',gray:'#8f8c85',charcoal:'#3a3a37',slate:'#5c6169',silver:'#c8c6bf',nude:'#d8bfa3',taupe:'#b3a394',mauve:'#a98a94',stone:'#c2b9aa',sand:'#d8c7a6',bone:'#e6dfc8',grullo:'#7d7568',bronze:'#8c6a3f',copper:'#a5642e',heaven:'#a8c3d9',desert:'#c9a97e','byzantine blue':'#28406b',ecru:'#e6dfc8',sable:'#4b2e22'};
  function swatchColor(name){
    var key = String(name || '').toLowerCase().trim();
    if(COLORMAP[key]) return COLORMAP[key];
    var parts = key.split(/[\s/\-]+/);
    for(var i=0;i<parts.length;i++){ if(COLORMAP[parts[i]]) return COLORMAP[parts[i]]; }
    return name;
  }
  function isColorOptionName(name){ return /^colou?r$/i.test(String(name||'').trim()); }
  window.YG.swatchColor = swatchColor; window.YG.isColorOptionName = isColorOptionName;

  function qaBaseChosen(data){
    const chosen = new Array(data.opts.length).fill(null);
    for(let i=0;i<data.opts.length;i++){
      if(data.steps.indexOf(i) < 0){ chosen[i] = data.v.length ? data.v[0].o[i] : null; }
    }
    return chosen;
  }
  function qaPrefill(qa){
    const dataEl = qa.parentNode.querySelector('[data-qa-data]');
    const stepWrap = qa.querySelector('[data-qa-step]');
    if(!dataEl || !stepWrap) return;
    let data; try{ data = JSON.parse(dataEl.textContent); }catch(err){ return; }
    qa._qaData = data;
    qa._qaStepPtr = 0;
    qa._qaChosen = qaBaseChosen(data);
    qaRender(qa);
  }
  function qaInitAll(root){
    (root||document).querySelectorAll('.qa[data-qa]').forEach(qa=>{
      if(qa._qaReady) return;
      qa._qaReady = true;
      qaPrefill(qa);
    });
  }
  function qaDone(qa){
    if(!qa) return;
    qa.classList.add('done');
    setTimeout(()=>{ qa.classList.remove('done');
      if(qa._qaData){ qa._qaStepPtr=0; qa._qaChosen=qaBaseChosen(qa._qaData); qaRender(qa); }
    },1500);
  }
  function qaRender(qa){
    const data=qa._qaData, ptr=qa._qaStepPtr, chosen=qa._qaChosen;
    const gi = data.steps[ptr];
    const chipsEl=qa.querySelector('[data-qa-chips]');
    const labEl=qa.querySelector('[data-qa-lab]');
    const backEl=qa.querySelector('[data-qa-back]');
    if(backEl) backEl.hidden = (ptr === 0);
    if(labEl){
      labEl.hidden = (ptr !== 0);
      labEl.textContent = 'Add';
    }
    const seen=[], avail={};
    data.v.forEach(v=>{
      for(let k=0;k<data.opts.length;k++){
        if(k===gi) continue;
        if(chosen[k]!=null && v.o[k]!==chosen[k]) return;
      }
      const val=v.o[gi];
      if(seen.indexOf(val)<0) seen.push(val);
      if(v.a) avail[val]=true;
    });
    const isColor = isColorOptionName(data.opts[gi]);
    chipsEl.innerHTML=seen.map(val=>{
      const dis=avail[val]?'':' disabled';
      const safeVal=String(val).replace(/"/g,'&quot;');
      if(isColor){
        const bg=swatchColor(val);
        return '<button class="qa-chip sw" style="background:'+bg+'" data-qa-val="'+safeVal+'"'+dis+' title="'+safeVal+'" aria-label="'+safeVal+'"></button>';
      }
      const short=String(val).split(' (')[0];
      return '<button class="qa-chip" data-qa-val="'+safeVal+'"'+dis+'>'+short+'</button>';
    }).join('');
    chipsEl.scrollLeft=0;
  }
  qaInitAll();
  window.YG.qaInitAll = qaInitAll;

  function pcMediaInitOne(card){
    if(card._pcReady) return;
    card._pcReady = true;
    const wrap = card.querySelector('[data-pc-imgwrap]');
    const slides = [].slice.call(card.querySelectorAll('[data-pc-slide]'));
    const dots = [].slice.call(card.querySelectorAll('[data-pc-dots] .pc-dot'));
    if(!wrap || slides.length < 2) return;
    let idx = 0, startX = 0, startY = 0, dragging = false, swiped = false;
    function show(i){
      idx = Math.max(0, Math.min(slides.length - 1, i));
      slides.forEach((s, si)=> s.classList.toggle('active', si === idx));
      dots.forEach((d, di)=> d.classList.toggle('on', di === idx));
    }
    wrap.addEventListener('pointerdown', (e)=>{
      if(e.pointerType === 'mouse') return;
      dragging = true; swiped = false; startX = e.clientX; startY = e.clientY;
    }, { passive: true });
    wrap.addEventListener('pointermove', (e)=>{
      if(!dragging) return;
      if(Math.abs(e.clientX - startX) > 12) swiped = true;
    }, { passive: true });
    wrap.addEventListener('pointerup', (e)=>{
      if(!dragging) return;
      dragging = false;
      const dx = e.clientX - startX, dy = e.clientY - startY;
      if(Math.abs(dx) > 30 && Math.abs(dx) > Math.abs(dy)){
        show(idx + (dx < 0 ? 1 : -1));
        swiped = true;
      }
    });
    wrap.addEventListener('pointercancel', ()=>{ dragging = false; });
    wrap.addEventListener('click', (e)=>{
      if(swiped){ e.preventDefault(); e.stopPropagation(); swiped = false; }
    }, true);
  }
  function pcMediaInitAll(root){
    (root||document).querySelectorAll('.pc[data-pc]').forEach(pcMediaInitOne);
  }
  pcMediaInitAll();
  window.YG.pcMediaInitAll = pcMediaInitAll;

  function pcColorPaint(root){
    if(!window.YG || typeof window.YG.swatchColor !== 'function') return false;
    (root||document).querySelectorAll('.pc-color-dot [data-col-swatch]').forEach(function(sw){
      var btn = sw.closest('.pc-color-dot');
      var name = btn ? btn.getAttribute('data-swatch-name') : '';
      var color = window.YG.swatchColor(name);
      if(color && /^#/.test(color)){ sw.style.background = color; }
    });
    return true;
  }
  if(!pcColorPaint()){
    document.addEventListener('DOMContentLoaded', function(){ pcColorPaint(); });
    setTimeout(pcColorPaint, 300);
  }
  window.YG.pcColorPaint = pcColorPaint;

  if(window.MutationObserver){
    var pcColorObserver = new MutationObserver(function(mutations){
      mutations.forEach(function(m){
        (m.addedNodes || []).forEach(function(n){
          if(!n || n.nodeType !== 1) return;
          if(n.matches && n.matches('.pc-color-dot')){ pcColorPaint(n.parentNode || document); return; }
          if(n.querySelector && n.querySelector('.pc-color-dot [data-col-swatch]')){ pcColorPaint(n); }
        });
      });
    });
    pcColorObserver.observe(document.body, { childList: true, subtree: true });
  }

  document.addEventListener('click', function(e){
    var dot = e.target.closest('.pc-color-dot');
    if(!dot) return;
    e.preventDefault(); e.stopPropagation();
    var card = dot.closest('.pc');
    if(!card) return;
    var img = dot.getAttribute('data-pc-color-img');
    if(!img) return;
    var activeSlide = card.querySelector('.pc-img-slide.active') || card.querySelector('.pc-img-slide');
    if(activeSlide) activeSlide.src = img;
    card.querySelectorAll('.pc-color-dot').forEach(function(d){ d.classList.toggle('sel', d===dot); });
  });

  document.addEventListener('click', async (e)=>{
    const addBtn=e.target.closest('[data-qa-add]');
    if(addBtn){ e.preventDefault(); e.stopPropagation();
      const qa=addBtn.closest('.qa');
      const ok=await addToCart(addBtn.getAttribute('data-variant'),1);
      if(ok){ qaDone(qa); openCart(); }
      return;
    }
    const backBtn=e.target.closest('[data-qa-back]');
    if(backBtn){ e.preventDefault(); e.stopPropagation();
      const qa=backBtn.closest('.qa');
      if(qa._qaStepPtr>0){ qa._qaStepPtr--; qaRender(qa); }
      return;
    }
    const chip=e.target.closest('[data-qa-val]');
    if(chip){ e.preventDefault(); e.stopPropagation();
      if(chip.disabled) return;
      const qa=chip.closest('.qa');
      const data=qa._qaData;
      const gi=data.steps[qa._qaStepPtr];
      qa._qaChosen[gi]=chip.getAttribute('data-qa-val');
      if(qa._qaStepPtr < data.steps.length-1){ qa._qaStepPtr++; qaRender(qa); }
      else {
        const chosen=qa._qaChosen;
        const match=data.v.find(v=> v.a && data.opts.every((_,k)=>v.o[k]===chosen[k]));
        if(match){ const ok=await addToCart(match.id,1); if(ok){ qaDone(qa); openCart(); } }
        else { toast('That combination is unavailable'); }
      }
      return;
    }
  });

  const so = document.getElementById('SearchOverlay');
  const searchHeader = document.querySelector('.site-header');
  if(so && searchHeader){
    const input = document.querySelector('[data-search-input]');
    const searchGroup = document.querySelector('[data-search-group]');
    const logoEl = document.querySelector('.site-header .logo');
    const results = so.querySelector('[data-search-results]');
    function updateSearchMaxWidth(){
      if(!searchGroup || !logoEl) return;
      var groupRect = searchGroup.getBoundingClientRect();
      var logoRect = logoEl.getBoundingClientRect();
      var avail = Math.floor(groupRect.left - logoRect.right - 20);
      avail = Math.max(0, Math.min(avail, 240));
      searchHeader.style.setProperty('--yg-search-max', avail + 'px');
    }
    function updateSearchBarTop(){
      if(!searchHeader) return;
      var r = searchHeader.getBoundingClientRect();
      var top = Math.max(0, Math.round(r.bottom));
      searchHeader.style.setProperty('--yg-search-top', top + 'px');
      searchHeader.style.setProperty('--yg-search-bottom', (top + 56) + 'px');
    }
    function isMobileSearch(){ return window.matchMedia && window.matchMedia('(max-width:820px)').matches; }
    function openSearch(){
      updateSearchMaxWidth();
      updateSearchBarTop();
      searchHeader.classList.add('search-open');
      if(isMobileSearch()){ document.body.classList.add('yg-search-lock'); }
      if(input){ input.focus(); }
    }
    function closeSearch(){
      searchHeader.classList.remove('search-open');
      searchHeader.classList.remove('has-results');
      document.body.classList.remove('yg-search-lock');
      so.classList.remove('open');
      if(input){ input.value=''; input.blur(); }
      if(results){ results.innerHTML=''; }
    }
    window.YG.closeSearch = closeSearch;
    document.querySelectorAll('[data-search-open]').forEach(b=>b.addEventListener('click',e=>{
      e.preventDefault();
      if(searchHeader.classList.contains('search-open')){
        if(isMobileSearch()){
          var q = input && input.value.trim();
          if(q){ window.location.href = '/search?q=' + encodeURIComponent(q); }
          else if(input){ input.focus(); }
        } else {
          closeSearch();
        }
      } else {
        openSearch();
      }
    }));
    so.querySelectorAll('[data-search-close]').forEach(b=>b.addEventListener('click',closeSearch));
    addEventListener('keydown',e=>{if(e.key==='Escape')closeSearch();});
    addEventListener('resize',()=>{ if(searchHeader.classList.contains('search-open')){ updateSearchMaxWidth(); updateSearchBarTop(); } });

    input && input.addEventListener('keydown', function(e){
      if(e.key === 'Enter'){
        e.preventDefault();
        var q = input.value.trim();
        if(q){ window.location.href = '/search?q=' + encodeURIComponent(q); }
      }
    });

    let st, controller;
    input && input.addEventListener('input',()=>{
      clearTimeout(st);
      const q = input.value.trim();
      if(q.length < 2){ results.innerHTML=''; so.classList.remove('open'); searchHeader.classList.remove('has-results'); return; }
      st = setTimeout(()=>runSearch(q), 240);
    });
    async function runSearch(q){
      so.classList.add('open');
      searchHeader.classList.add('has-results');
      if(controller) controller.abort();
      controller = new AbortController();
      try{
        const url = '/search/suggest.json?q=' + encodeURIComponent(q) +
          '&resources[type]=product&resources[limit]=8&resources[options][unavailable_products]=last&resources[options][fields]=title,product_type,variants.title,vendor';
        const r = await fetch(url, {signal: controller.signal});
        const data = await r.json();
        const products = (((data||{}).resources||{}).results||{}).products || [];
        if(!products.length){ results.innerHTML = '<div class="so-hint">No results for "'+q+'"</div>'; return; }
        results.innerHTML =
          '<div class="so-hint">Products</div><div class="so-grid">' +
          products.map(p=>{
            const img = p.image || (p.featured_image && p.featured_image.url) || '';
            const price = p.price ? (typeof p.price === 'number' ? money(p.price) : p.price) : '';
            return '<a class="so-item" href="'+p.url+'"><img src="'+img+'" alt="" loading="lazy"><div class="n">'+p.title+'</div><div class="p">'+price+'</div></a>';
          }).join('') +
          '</div><a class="so-all" href="/search?q='+encodeURIComponent(q)+'">See all results →</a>';
      }catch(e){ if(e.name!=='AbortError'){ results.innerHTML=''; } }
    }
  }

  (function(){
    var typedEl = document.querySelector('[data-si-typed]');
    if(!typedEl) return;
    var words = ['black top', 'silk blouse', 'lord sweater', 'satin dress', 'denim jacket'];
    var wi = 0, i = 0, deleting = false;
    function tick(){
      var word = words[wi];
      if(!deleting){
        i++;
        typedEl.textContent = word.slice(0, i);
        if(i >= word.length){ deleting = true; setTimeout(tick, 1500); return; }
        setTimeout(tick, 95);
      } else {
        i--;
        typedEl.textContent = word.slice(0, i);
        if(i <= 0){ deleting = false; wi = (wi + 1) % words.length; setTimeout(tick, 550); return; }
        setTimeout(tick, 45);
      }
    }
    setTimeout(tick, 700);
  })();

  var WISH_KEY = 'yg_wishlist';
  function wishGet(){ try{ return JSON.parse(localStorage.getItem(WISH_KEY)||'[]'); }catch(e){ return []; } }
  function wishSave(list){ try{ localStorage.setItem(WISH_KEY, JSON.stringify(list)); }catch(e){} }
  function wishHas(id){ return wishGet().some(function(i){ return String(i.id)===String(id); }); }
  function wishToggle(item){
    var list = wishGet();
    var idx = -1;
    for(var i=0;i<list.length;i++){ if(String(list[i].id)===String(item.id)){ idx=i; break; } }
    if(idx>-1){ list.splice(idx,1); } else { list.unshift(item); }
    wishSave(list);
    wishRenderAll();
    return idx===-1;
  }
  function wishRemove(id){
    var list = wishGet().filter(function(i){ return String(i.id)!==String(id); });
    wishSave(list);
    wishRenderAll();
  }
  function wishRenderAll(){
    var list = wishGet();
    document.querySelectorAll('[data-wish-toggle]').forEach(function(btn){
      var id = btn.getAttribute('data-wish-id');
      var on = list.some(function(i){ return String(i.id)===String(id); });
      btn.classList.toggle('on', on);
      btn.setAttribute('aria-pressed', on ? 'true' : 'false');
    });
    document.querySelectorAll('[data-wish-count]').forEach(function(el){ el.textContent = list.length; });
    document.querySelectorAll('[data-wish-badge]').forEach(function(el){
      el.textContent = list.length;
      if(list.length > 0){ el.setAttribute('data-on',''); } else { el.removeAttribute('data-on'); }
    });
    document.dispatchEvent(new CustomEvent('yg:wishlist-change', {detail:{list:list}}));
  }
  document.addEventListener('click', function(e){
    var btn = e.target.closest('[data-wish-toggle]');
    if(!btn) return;
    e.preventDefault(); e.stopPropagation();
    var item = {
      id: btn.getAttribute('data-wish-id'),
      handle: btn.getAttribute('data-wish-handle'),
      title: btn.getAttribute('data-wish-title'),
      price: btn.getAttribute('data-wish-price'),
      image: btn.getAttribute('data-wish-image'),
      url: btn.getAttribute('data-wish-url')
    };
    var added = wishToggle(item);
    toast(added ? 'Saved to wishlist' : 'Removed from wishlist');
  });
  wishRenderAll();
  window.YG.wishGet = wishGet; window.YG.wishHas = wishHas; window.YG.wishToggle = wishToggle; window.YG.wishRemove = wishRemove; window.YG.wishRenderAll = wishRenderAll;

  document.querySelectorAll('[data-tabs]').forEach(group=>{
    const btns=[...group.querySelectorAll('.tab')];
    const panels=[...group.querySelectorAll('[data-panel]')];
    btns.forEach(b=>b.addEventListener('click',()=>{
      btns.forEach(x=>x.classList.remove('on'));b.classList.add('on');
      const i=b.getAttribute('data-i');
      panels.forEach(p=>p.hidden = p.getAttribute('data-panel')!==i);
      bindReveals(group);
    }));
  });
})();

/* ===== sitewide scroll-entry reveal system (data-reveal / data-reveal-group / data-reveal-item) ===== */
(function(){
  var reduceMotion = !!(window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches);
  var revealIO = null;
  if(!reduceMotion && 'IntersectionObserver' in window){
    revealIO = new IntersectionObserver(function(entries){
      entries.forEach(function(entry){
        if(!entry.isIntersecting) return;
        entry.target.classList.add('is-revealed');
        revealIO.unobserve(entry.target);
      });
    }, { threshold: 0.15, rootMargin: '0px 0px -10% 0px' });
  }

  function initReveals(root){
    root = root || document;
    if(!root.querySelectorAll) return;

    if(reduceMotion || !revealIO){
      root.querySelectorAll('[data-reveal], [data-reveal-item]').forEach(function(el){
        el.classList.add('is-revealed');
      });
      return;
    }

    root.querySelectorAll('[data-reveal]:not(.is-revealed)').forEach(function(el){
      revealIO.observe(el);
    });

    root.querySelectorAll('[data-reveal-group]').forEach(function(group){
      var items = group.querySelectorAll('[data-reveal-item]:not(.is-revealed)');
      items.forEach(function(el, i){
        if(!el.style.transitionDelay){ el.style.transitionDelay = (i * 80) + 'ms'; }
        revealIO.observe(el);
      });
    });
  }

  initReveals();

  window.YG = window.YG || {};
  window.YG.initReveals = initReveals;

  document.addEventListener('yg:contentswap', function(e){
    initReveals((e.detail && e.detail.root) || document);
  });
})();

document.addEventListener('shopify:section:load', function(e){
  var root = e.target || document;
  if(window.YG){
    if(typeof window.YG.bindReveals === 'function'){ window.YG.bindReveals(root); }
    if(typeof window.YG.initReveals === 'function'){ window.YG.initReveals(root); }
    if(typeof window.YG.qaInitAll === 'function'){ window.YG.qaInitAll(root); }
    if(typeof window.YG.pcMediaInitAll === 'function'){ window.YG.pcMediaInitAll(root); }
    if(typeof window.YG.pcColorPaint === 'function'){ window.YG.pcColorPaint(root); }
    if(typeof window.YG.wishRenderAll === 'function'){ window.YG.wishRenderAll(); }
  }
});
document.addEventListener('shopify:section:select', function(e){
  var root = e.target || document;
  if(window.YG){
    if(typeof window.YG.bindReveals === 'function'){ window.YG.bindReveals(root); }
    if(typeof window.YG.initReveals === 'function'){ window.YG.initReveals(root); }
  }
});

(function(){
  var header = document.querySelector('.site-header');
  if(!header) return;

  var HERO_THRESHOLD_PX = 80;
  var isDark = false, ticking = false, announceH = 0;

  function computeAnnounceHeight(){
    var main = document.getElementById('MainContent');
    var firstSection = main && main.firstElementChild;
    var bar = firstSection && firstSection.querySelector && firstSection.querySelector('.yg-ann');
    announceH = bar ? bar.offsetHeight : 0;
  }

  function detectHeroPage(root){
    var scope = root || document.getElementById('MainContent') || document;
    isDark = !!(scope.querySelector && (scope.querySelector('.yg-hero-photo') || scope.querySelector('.give-screen')));
    var wrap = document.querySelector('.shopify-section-group-header-group');
    if(wrap){ wrap.classList.toggle('is-floating', isDark); }
  }

  function applyState(){
    if(!isDark){ header.classList.remove('is-transparent'); return; }
    var y = window.scrollY || window.pageYOffset || 0;
    var offset = Math.max(0, announceH - y);
    document.documentElement.style.setProperty('--yg-announce-h', offset + 'px');
    header.classList.toggle('is-transparent', y <= (announceH + HERO_THRESHOLD_PX));
  }

  function onScroll(){
    if(ticking) return;
    ticking = true;
    requestAnimationFrame(function(){ applyState(); ticking = false; });
  }

  function refresh(root){
    detectHeroPage(root);
    computeAnnounceHeight();
    applyState();
  }

  refresh();
  addEventListener('scroll', onScroll, { passive: true });
  addEventListener('resize', function(){ computeAnnounceHeight(); applyState(); });
  if(document.fonts && document.fonts.ready){ document.fonts.ready.then(function(){ computeAnnounceHeight(); applyState(); }); }
  document.addEventListener('yg:contentswap', function(e){
    refresh(e.detail && e.detail.root);
  });
})();

(function(){
  var main = document.getElementById('MainContent');
  if(!main || !window.fetch || !window.DOMParser || !window.history || !history.pushState) return;

  var EXCLUDE_SUBSTR = ['/cart', '/checkout', '/account', '/challenge', '/apple-pay', '/search', '.pdf'];
  var inFlight = false;

  var ALLOWED_STYLES = ['veil', 'turn', 'none'];
  var TRANS_TIMING = { turn:{out:200,in:260}, veil:{out:140,in:160}, none:{out:0,in:0} };

  function isExcludedHref(href){
    for(var i=0;i<EXCLUDE_SUBSTR.length;i++){
      if(href.indexOf(EXCLUDE_SUBSTR[i]) > -1) return true;
    }
    return false;
  }

  function cleanupStrayAppWidgets(){
    var candidates = document.querySelectorAll('[id*="fittingRoom" i], [class*="fitting-room" i]');
    candidates.forEach(function(el){
      if(main.contains(el)) return;
      el.remove();
    });
  }

  function reinitSwappedContent(root){
    document.dispatchEvent(new CustomEvent('yg:contentswap', { detail: { root: root } }));
    if(window.YG){
      if(typeof window.YG.closeSearch === 'function'){ window.YG.closeSearch(); }
      if(typeof window.YG.initReveals === 'function'){ window.YG.initReveals(root); }
      if(typeof window.YG.bindReveals === 'function'){ window.YG.bindReveals(root); }
      if(typeof window.YG.qaInitAll === 'function'){ window.YG.qaInitAll(root); }
      if(typeof window.YG.pcMediaInitAll === 'function'){ window.YG.pcMediaInitAll(root); }
      if(typeof window.YG.pcColorPaint === 'function'){ window.YG.pcColorPaint(root); }
      if(typeof window.YG.wishRenderAll === 'function'){ window.YG.wishRenderAll(); }
    }
    if(window.jdgm && typeof window.jdgm.initializeWidgets === 'function'){
      try{ window.jdgm.initializeWidgets(); }catch(e){}
    }
  }

  function runScripts(root){
    var scripts = [].slice.call(root.querySelectorAll('script'));
    scripts.forEach(function(old){
      var s = document.createElement('script');
      for(var i=0;i<old.attributes.length;i++){
        var a = old.attributes[i];
        s.setAttribute(a.name, a.value);
      }
      if(!old.src){ s.textContent = old.textContent; }
      old.parentNode.replaceChild(s, old);
    });
  }

  function ensureFX(){
    if(document.getElementById('yg-trans-fx')) return;
    var fx = document.createElement('div');
    fx.id = 'yg-trans-fx';
    fx.setAttribute('aria-hidden', 'true');
    fx.innerHTML =
      '<div class="yg-veil yg-veil-l"></div>' +
      '<div class="yg-veil yg-veil-r"></div>' +
      '<div class="yg-veil-seam"></div>';
    document.body.appendChild(fx);
  }

  function runExitFX(style){
    if(style === 'veil'){
      var vl = document.querySelector('#yg-trans-fx .yg-veil-l');
      var vr = document.querySelector('#yg-trans-fx .yg-veil-r');
      var seam = document.querySelector('#yg-trans-fx .yg-veil-seam');
      if(vl){ vl.classList.remove('opening'); vl.classList.add('closing'); }
      if(vr){ vr.classList.remove('opening'); vr.classList.add('closing'); }
      if(seam){ seam.classList.add('show'); }
    }
  }

  function runEnterFX(style){
    if(style === 'veil'){
      var vl = document.querySelector('#yg-trans-fx .yg-veil-l');
      var vr = document.querySelector('#yg-trans-fx .yg-veil-r');
      var seam = document.querySelector('#yg-trans-fx .yg-veil-seam');
      if(vl){ vl.classList.remove('closing'); vl.classList.add('opening'); }
      if(vr){ vr.classList.remove('closing'); vr.classList.add('opening'); }
      if(seam){ seam.classList.remove('show'); }
    }
  }

  var savedStyle = (window.YG && ALLOWED_STYLES.indexOf(window.YG.transition_style) > -1) ? window.YG.transition_style : 'veil';
  document.body.setAttribute('data-yg-trans', savedStyle);
  ensureFX();

  function doSwap(url, push, dir, forceInstant){
    if(inFlight) return;
    inFlight = true;
    cleanupStrayAppWidgets();

    var style = forceInstant ? 'none' : (document.body.getAttribute('data-yg-trans') || 'veil');
    var timing = TRANS_TIMING[style] || TRANS_TIMING.veil;
    document.body.setAttribute('data-yg-dir', dir || 'forward');
    var isRealPageNav = !forceInstant;

    if(style !== 'none'){
      main.classList.add('is-transitioning-out');
      runExitFX(style);
    }

    var settle = new Promise(function(resolve){ setTimeout(resolve, timing.out); });
    var load = fetch(url, { credentials: 'same-origin' }).then(function(r){
      if(!r.ok) throw new Error('bad status ' + r.status);
      return r.text();
    });

    Promise.all([settle, load]).then(function(res){
      var html = res[1];
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var newMain = doc.getElementById('MainContent');
      if(!newMain){ throw new Error('no #MainContent in response'); }

      cleanupStrayAppWidgets();
      main.innerHTML = newMain.innerHTML;
      if(doc.body){ document.body.className = doc.body.className; }
      if(doc.title){ document.title = doc.title; }
      if(push){ history.pushState({ ygSoftNav: true }, '', url); }
      if(isRealPageNav){ window.scrollTo(0, 0); }

      runScripts(main);
      reinitSwappedContent(main);

      if(style !== 'none'){
        main.classList.remove('is-transitioning-out');
        main.classList.add('is-transitioning-in');
        runEnterFX(style);
        requestAnimationFrame(function(){
          requestAnimationFrame(function(){ main.classList.remove('is-transitioning-in'); });
        });
        setTimeout(function(){ main.classList.remove('is-transitioning-in'); }, timing.in);
      }

      inFlight = false;
    }).catch(function(){
      inFlight = false;
      window.location.href = url;
    });
  }

  window.YG.instantNav = function(href){
    var url;
    try{ url = new URL(href, window.location.href); }catch(err){ window.location.href = href; return; }
    if(url.origin !== window.location.origin){ window.location.href = href; return; }
    doSwap(url.pathname + url.search + url.hash, true, 'forward', true);
  };

  document.addEventListener('click', function(e){
    if(e.defaultPrevented || e.button !== 0) return;
    if(e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;

    var a = e.target && e.target.closest && e.target.closest('a[href]');
    if(!a) return;
    if(a.hasAttribute('data-no-transition')) return;
    if(a.target && a.target !== '' && a.target !== '_self') return;
    if(a.hasAttribute('download')) return;

    var href = a.getAttribute('href') || '';
    if(!href || href.charAt(0) === '#') return;
    if(/^(mailto:|tel:|sms:|javascript:)/i.test(href)) return;

    var url;
    try{ url = new URL(a.href, window.location.href); }catch(err){ return; }
    if(url.origin !== window.location.origin) return;
    if(isExcludedHref(url.pathname + url.search)) return;

    var forceInstant = a.hasAttribute('data-instant-nav');

    e.preventDefault();
    doSwap(url.pathname + url.search + url.hash, true, 'forward', forceInstant);
  });

  addEventListener('popstate', function(){
    doSwap(location.pathname + location.search + location.hash, false, 'back');
  });
})();

(function(){
  document.addEventListener('click', function(e){
    if(e.defaultPrevented || e.button !== 0) return;
    if(e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;

    var a = e.target && e.target.closest && e.target.closest('a[href^="#"]');
    if(!a) return;

    var href = a.getAttribute('href') || '';
    if(href.length < 2) return;

    var id = decodeURIComponent(href.slice(1));
    var target = document.getElementById(id);
    if(!target) return;

    e.preventDefault();

    var headerH = parseInt(getComputedStyle(document.documentElement).getPropertyValue('--header-h'), 10) || 0;
    var top = target.getBoundingClientRect().top + window.pageYOffset - headerH - 16;
    window.scrollTo({ top: Math.max(0, top), behavior: 'smooth' });

    if(history.pushState){ history.pushState(null, '', href); } else { window.location.hash = href; }
  });
})();

(function(){
  function isMobile(){ return window.matchMedia && window.matchMedia('(max-width:760px)').matches; }

  function getCardData(trigger){
    var wrap = trigger.closest('.pc-media, .im, .ce-item');
    if(!wrap) return null;
    var qa = wrap.querySelector('.qa[data-qa]');
    var dataEl = wrap.querySelector('[data-qa-data]');
    var soldLink = wrap.querySelector('.qa-sold');
    var addBtn = wrap.querySelector('[data-qa-add]');
    return { wrap: wrap, qa: qa, dataEl: dataEl, soldLink: soldLink, addBtn: addBtn };
  }

  function getCardMeta(trigger){
    var card = trigger.closest('.pc, .sp, .ce-item') || trigger.closest('[data-pc]');
    var title = '', price = '';
    if(card){
      var n = card.querySelector('.pc-n, .row1 .n, .ce-n');
      var p = card.querySelector('.pc-p, .row1 .p, .ce-p');
      if(n) title = n.textContent.trim();
      if(p) price = p.textContent.trim();
    }
    return { title: title, price: price };
  }

  var sheetEl, sheetState = {};

  function ensureSheet(){
    if(sheetEl) return sheetEl;
    sheetEl = document.createElement('div');
    sheetEl.className = 'qa-sheet';
    sheetEl.innerHTML =
      '<div class="qs-scrim" data-qs-scrim></div>' +
      '<div class="qs-panel" data-qs-panel>' +
        '<div class="qs-grip"></div>' +
        '<div class="qs-head">' +
          '<div><span class="qs-title" data-qs-title></span><span class="qs-price" data-qs-price></span></div>' +
          '<button type="button" class="qs-close" data-qs-close aria-label="Close">&times;</button>' +
        '</div>' +
        '<div class="qs-body" data-qs-body></div>' +
        '<div class="qs-foot"><button type="button" class="qs-add" data-qs-add disabled>Select size</button></div>' +
      '</div>';
    document.body.appendChild(sheetEl);

    sheetEl.querySelector('[data-qs-scrim]').addEventListener('click', closeSheet);
    sheetEl.querySelector('[data-qs-close]').addEventListener('click', closeSheet);
    addEventListener('keydown', function(e){ if(e.key === 'Escape') closeSheet(); });

    var panel = sheetEl.querySelector('[data-qs-panel]');
    var startY = null, curY = null, dragging = false;
    panel.addEventListener('touchstart', function(e){
      if(e.target.closest('.qs-body')) {
        if(e.target.closest('[data-qs-body]')) return;
      }
      startY = e.touches[0].clientY; dragging = true; panel.style.transition = 'none';
    }, { passive: true });
    panel.addEventListener('touchmove', function(e){
      if(!dragging || startY == null) return;
      curY = e.touches[0].clientY;
      var dy = Math.max(0, curY - startY);
      panel.style.transform = 'translateY(' + dy + 'px)';
    }, { passive: true });
    panel.addEventListener('touchend', function(){
      if(!dragging) return;
      dragging = false;
      panel.style.transition = '';
      var dy = (curY != null && startY != null) ? (curY - startY) : 0;
      panel.style.transform = '';
      startY = curY = null;
      if(dy > 90) closeSheet();
    });

    sheetEl.querySelector('[data-qs-add]').addEventListener('click', function(){
      var btn = this;
      if(btn.disabled || !sheetState.matchedVariant) return;
      window.YG.addToCart(sheetState.matchedVariant.id, 1).then(function(ok){
        if(ok){ closeSheet(); window.YG.openCart(); }
      });
    });

    return sheetEl;
  }

  function closeSheet(){
    if(!sheetEl) return;
    sheetEl.classList.remove('open');
    document.body.style.overflow = '';
    sheetState = {};
  }

  function baseChosen(data){
    var chosen = new Array(data.opts.length).fill(null);
    for(var i=0;i<data.opts.length;i++){
      if(data.steps.indexOf(i) < 0){ chosen[i] = data.v.length ? data.v[0].o[i] : null; }
    }
    return chosen;
  }

  function renderSheetGroups(){
    var sheet = ensureSheet();
    var data = sheetState.data, chosen = sheetState.chosen;
    var body = sheet.querySelector('[data-qs-body]');
    var html = '';
    data.steps.forEach(function(gi){
      var label = data.opts[gi];
      var isColor = window.YG.isColorOptionName(label);
      var seen = [], avail = {};
      data.v.forEach(function(v){
        for(var k=0;k<data.opts.length;k++){
          if(k === gi) continue;
          if(chosen[k] != null && v.o[k] !== chosen[k]) return;
        }
        var val = v.o[gi];
        if(seen.indexOf(val) < 0) seen.push(val);
        if(v.a) avail[val] = true;
      });
      html += '<div class="qs-group"><div class="qs-group-lab">' + label + '</div><div class="qs-chips">';
      html += seen.map(function(val){
        var dis = avail[val] ? '' : ' disabled';
        var sel = (chosen[gi] === val) ? ' sel' : '';
        var safeVal = String(val).replace(/"/g,'&quot;');
        if(isColor){
          var bg = window.YG.swatchColor(val);
          return '<button type="button" class="qs-chip sw' + sel + '" style="background:' + bg + '" data-qs-val="' + safeVal + '" data-qs-gi="' + gi + '"' + dis + ' title="' + safeVal + '" aria-label="' + safeVal + '"></button>';
        }
        return '<button type="button" class="qs-chip' + sel + '" data-qs-val="' + safeVal + '" data-qs-gi="' + gi + '"' + dis + '>' + val + '</button>';
      }).join('');
      html += '</div></div>';
    });
    body.innerHTML = html;
    body.querySelectorAll('[data-qs-val]').forEach(function(chip){
      chip.addEventListener('click', function(){
        if(chip.disabled) return;
        var gi = parseInt(chip.getAttribute('data-qs-gi'), 10);
        sheetState.chosen[gi] = chip.getAttribute('data-qs-val');
        renderSheetGroups();
        updateAddButton();
      });
    });
    updateAddButton();
  }

  function updateAddButton(){
    var sheet = ensureSheet();
    var addBtn = sheet.querySelector('[data-qs-add]');
    var data = sheetState.data, chosen = sheetState.chosen;
    var complete = data.steps.every(function(gi){ return chosen[gi] != null; });
    if(!complete){
      addBtn.disabled = true; addBtn.textContent = 'Select size'; sheetState.matchedVariant = null;
      return;
    }
    var match = data.v.find(function(v){ return data.opts.every(function(_, k){ return v.o[k] === chosen[k]; }); });
    if(match && match.a){
      addBtn.disabled = false; addBtn.textContent = 'Add to bag'; sheetState.matchedVariant = match;
    } else {
      addBtn.disabled = true; addBtn.textContent = match ? 'Sold out' : 'Unavailable'; sheetState.matchedVariant = null;
    }
  }

  function openSheet(dataEl, meta){
    var data; try{ data = JSON.parse(dataEl.textContent); }catch(e){ return; }
    var sheet = ensureSheet();
    sheet.querySelector('[data-qs-title]').textContent = meta.title || '';
    sheet.querySelector('[data-qs-price]').textContent = meta.price || '';
    sheetState = { data: data, chosen: baseChosen(data), matchedVariant: null };
    renderSheetGroups();
    sheet.classList.add('open');
    document.body.style.overflow = 'hidden';
  }

  document.addEventListener('click', function(e){
    var trigger = e.target.closest('.qa-trigger');
    if(!trigger) return;
    e.preventDefault(); e.stopPropagation();
    if(!isMobile()) return;

    var card = getCardData(trigger);
    if(!card) return;

    if(card.soldLink){
      window.location.href = card.soldLink.getAttribute('href');
      return;
    }
    if(card.dataEl){
      var meta = getCardMeta(trigger);
      openSheet(card.dataEl, meta);
      return;
    }
    if(card.addBtn){
      trigger.classList.add('is-active');
      window.YG.addToCart(card.addBtn.getAttribute('data-variant'), 1).then(function(ok){
        trigger.classList.remove('is-active');
        if(ok){ window.YG.openCart(); }
      });
      return;
    }
    if(card.qa){ card.qa.classList.toggle('qa-open'); }
  });
})();

/* ===== relocate wishlist heart when Essential Preorder & Back-In-Stock app takes over =====
   base.css hides .pdp-add (the native Add to Cart button) whenever the Essential Preorder app
   injects its own "Notify me when available" button into the sibling .essential-preorder-bis-
   button-placement div right after .pdp-addrow (both are direct children of the same .pdp-form
   flex-column container) -- that part works. But .pdp-wish (the wishlist heart) is a flex child
   of .pdp-addrow alongside .pdp-add, so hiding .pdp-add via CSS alone left the heart floating by
   itself inside an otherwise-empty row, with an awkward gap above the full-width Notify Me button
   below it -- looking like a broken layout rather than the normal Add to Cart + heart row. Since
   the preorder app mounts/unmounts its button asynchronously per variant selection (no event we
   can hook), we physically move the heart into the placement div next to the Notify Me button
   whenever it's present, and move it back the moment the variant is back in stock and the button
   is gone. Scoped to .pdp-form (there's normally exactly one per product page, but a quick-add
   modal could reuse the same classes, so this stays generic via querySelectorAll).

   Bug #211 additions: the Essential Preorder app also renders TWO more live "add to cart"
   surfaces that this relocation logic never touched, letting a shopper buy a sold-out variant
   through either of them while the Notify Me button is showing:
     1. The app's OWN duplicate "Add To Cart" button. It renders inside the SAME
        .essential-preorder-bis-button-placement div, as a sibling of the genuine
        "Made for you..." message inside [data-essential-preorder-element="container"]. It
        carries the same .pdp-add class as the real button, but because it sits one DOM level
        deeper (inside that container, not a direct sibling of .pdp-addrow), the existing
        base.css :has() rule that hides the top-level .pdp-add never reaches it -- confirmed live
        via getComputedStyle that it renders fully visible/clickable.
     2. The theme's own mobile sticky add-to-cart bar
        (.pdp-stickybar button.abtn[data-add][data-sticky]). This is pure theme markup living
        completely outside .pdp-form's app-managed subtree (in a fixed-position wrapper elsewhere
        in the DOM), so nothing above ever touched it either -- confirmed live that it shares the
        same data-variant as the main .pdp-add button and stays fully visible/clickable while
        Notify Me is showing.
   Both are matched off the SAME bisBtn presence check already driving the heart relocation, so
   all three surfaces flip visibility together, and back again in sync, without adding a second
   competing observer.

   Bug #213 additions (race condition -- blank button area, only the heart showing): confirmed via
   live inspection that base.css's ":has(+ .essential-preorder-bis-container-active button) .pdp-add"
   rule matches on DOM *presence* of a <button> anywhere inside the app's active container --
   including a button WE ourselves set to display:none (dupAddBtn below), and regardless of whether
   the app has actually rendered its own genuinely visible back-in-stock/backorder button yet. That
   opens a window -- most reproducibly right after switching variants, while the app is tearing down
   the previous variant's button and hasn't finished rendering the new one -- where: the active
   container already exists and already contains a button (so CSS keeps .pdp-add hidden), but
   neither bisBtn nor a visible purchase/duplicate button exists yet to take its place, and this
   function's own bisBtn-presence check doesn't hide/relocate anything either (since bisBtn is
   null), so addrow is left visible containing only the CSS-hidden .pdp-add and the wish heart --
   exactly the reported "blank gap, heart still shows" bug. The safety-net block below re-checks,
   on every call, whether the customer is about to be left with nothing purchasable/notify-able
   visible, and if so forces the native button back on with inline !important (which always wins
   over external-stylesheet !important) as a last resort -- self-healing the instant a real
   replacement (bisBtn or a visible dupAddBtn/purchase button) becomes visible on a later call. */
(function(){
  /* Genuine-visibility check used to gate the "Made for you..." message (see Bug #212 note
     below). A naive `getComputedStyle(el).display !== 'none'` check is NOT enough here because
     a hidden ANCESTOR (e.g. addrow being collapsed to display:none) doesn't change an element's
     own computed display -- offsetParent/getBoundingClientRect correctly account for that.
     Because this same function later hides dupAddBtn itself (see data-yg-hidden marker below),
     checking it again on a later tick would otherwise always read "hidden" even when the app's
     underlying purchase button is genuinely live -- so when the element was hidden BY US, this
     temporarily clears that inline style to measure the real underlying state, then restores it. */
  function isVisible(el){
    if(!el) return false;
    var hiddenByUs = el.getAttribute('data-yg-hidden') === '1';
    var prevDisplay = el.style.display;
    if(hiddenByUs){ el.style.display = ''; }
    var visible = el.offsetParent !== null;
    if(visible){
      var r = el.getBoundingClientRect();
      visible = r.width > 0 && r.height > 0;
    }
    if(hiddenByUs){ el.style.display = prevDisplay; }
    return visible;
  }
  function relocateWishForPreorder(root){
    (root || document).querySelectorAll('.pdp-addrow').forEach(function(addrow){
      var placement = addrow.nextElementSibling;
      if(!placement || !placement.classList || !placement.classList.contains('essential-preorder-bis-button-placement')) return;
      var bisBtn = placement.querySelector('[data-essential-preorder-element="back-in-stock-button"]');
      var row = placement.querySelector('.pdp-bis-row');
      var wish = addrow.querySelector('.pdp-wish') || (row && row.querySelector('.pdp-wish')) || placement.querySelector('.pdp-wish');
      /* .pdp-addrow can also contain a message container (data-essential-preorder-element="container",
         wrapping a data-essential-preorder-element="message" span) that the app shows on products the
         merchant configured with a message like "Made for you. Ships in 4 weeks" -- absent entirely on
         products without that config, so its presence/absence here is already correctly controlled by
         the app itself. It must render BELOW the button+heart row once relocated, not just get carried
         along with addrow's display:none (that was the bug: hiding the whole row hid this message too,
         even though it lives outside the row visually and should stay visible). Every move below is
         guarded by a parentElement check before touching the DOM: this function re-runs on every
         MutationObserver tick (including ticks caused by its OWN previous appendChild/insertBefore/
         remove calls), and calling appendChild/insertBefore on a node that's already in that exact slot
         still fires a new childList mutation in most browsers -- without the guards this becomes an
         infinite relocate -> mutate -> relocate loop that pegs the CPU and freezes the tab.

         Bug #212: this message was showing up UNDERNEATH the "Notify me when available" button
         even on plain out-of-stock products with no active preorder/backorder campaign -- i.e. its
         presence was being keyed off bisBtn alone. It must only ever be relocated/shown here when
         the app's own ACTIVE PURCHASE button ([data-essential-preorder-element="button"], e.g.
         labeled "Backorder") is genuinely present and visible -- that's the only case where the
         message is describing a real, live buy-now path, matching the app's own reference mockup
         (button on top, message below). When that purchase button isn't visible (pure "notify me,
         no campaign" state), the message is hidden outright instead of being carried into the
         placement div next to Notify Me. */
      var msg = addrow.querySelector('[data-essential-preorder-element="container"]') || placement.querySelector('[data-essential-preorder-element="container"]');

      /* Surface 2: the app's own duplicate "Add To Cart" button lives INSIDE that same
         [data-essential-preorder-element="container"] block, as a sibling of the genuine message
         span -- grabbing it this way means only the button itself gets hidden, never the message.
         This element doubles as the "is there a genuine active purchase path" signal for the
         message above -- its visibility is captured into purchaseBtnVisible BEFORE anything below
         hides it, via isVisible()'s data-yg-hidden-aware measurement. */
      var dupAddBtn = (msg && msg.querySelector) ? msg.querySelector('[data-essential-preorder-element="button"]') : null;
      if(!dupAddBtn){ dupAddBtn = placement.querySelector('[data-essential-preorder-element="button"]'); }
      var purchaseBtnVisible = isVisible(dupAddBtn);

      /* Surface 3: the mobile sticky add-to-cart bar button is matched to THIS product form via
         data-variant (both the real .pdp-add and the sticky bar's button carry the same variant
         id), so a page that somehow renders more than one product form never cross-hides the
         wrong bar. Falls back to any sticky button if no variant id is found, so it still degrades
         safely on the common single-product-form page. */
      var mainAddBtn = addrow.querySelector('.pdp-add[data-variant]');
      var variantId = mainAddBtn ? mainAddBtn.getAttribute('data-variant') : null;
      var stickyBtn = variantId ? document.querySelector('.pdp-stickybar .abtn[data-add][data-variant="' + variantId + '"]') : null;
      if(!stickyBtn){ stickyBtn = document.querySelector('.pdp-stickybar .abtn[data-add][data-sticky]'); }

      if(bisBtn && wish){
        if(!row){
          row = document.createElement('div');
          row.className = 'pdp-bis-row';
          row.style.display = 'flex';
          row.style.alignItems = 'center';
          row.style.gap = '10px';
          placement.insertBefore(row, placement.firstChild);
        }
        if(bisBtn.parentElement !== row){ bisBtn.style.flex = '1'; row.appendChild(bisBtn); }
        if(wish.parentElement !== row){ row.appendChild(wish); }
        if(msg){
          if(purchaseBtnVisible){
            if(msg.parentElement !== placement){ placement.appendChild(msg); }
            if(msg.style.display === 'none'){ msg.style.display = ''; }
          } else {
            if(msg.parentElement !== addrow){ addrow.appendChild(msg); }
            if(msg.style.display !== 'none'){ msg.style.display = 'none'; }
          }
        }
        if(addrow.style.display !== 'none'){ addrow.style.display = 'none'; }
        if(dupAddBtn && dupAddBtn.style.display !== 'none'){ dupAddBtn.style.display = 'none'; dupAddBtn.setAttribute('data-yg-hidden', '1'); }
        if(stickyBtn && stickyBtn.style.display !== 'none'){ stickyBtn.style.display = 'none'; }
      } else if(!bisBtn && (row || (wish && wish.parentElement === placement) || (msg && msg.parentElement === placement))){
        if(msg && msg.parentElement === placement){ addrow.appendChild(msg); }
        if(msg && msg.style.display === 'none'){ msg.style.display = ''; }
        if(wish && wish.parentElement !== addrow){ addrow.appendChild(wish); }
        if(row){ row.remove(); }
        addrow.style.display = '';
        placement.style.display = '';
        placement.style.alignItems = '';
        placement.style.gap = '';
        if(dupAddBtn && dupAddBtn.style.display === 'none'){ dupAddBtn.style.display = ''; dupAddBtn.removeAttribute('data-yg-hidden'); }
        if(stickyBtn && stickyBtn.style.display === 'none'){ stickyBtn.style.display = ''; }
      }

      /* Bug #213 safety net -- see the big comment above this IIFE for the full race-condition
         explanation. Re-derive, AFTER the branch above has run, whether the browser is about to
         (or already does) hide the native .pdp-add via base.css's ":has()" rule -- that rule fires
         off DOM *presence* of any <button> inside the app's active container, whether or not it's
         currently display:none -- and whether anything genuinely visible actually stands in for
         it right now. If not, force the native button visible via inline style with 'important'
         priority, which always wins over an external stylesheet's !important. This is intentionally
         re-evaluated on every call (MutationObserver tick, variant-change retry, etc.), so it turns
         itself off the instant bisBtn or a visible purchase/duplicate button shows up for real.

         IMPORTANT: use querySelectorAll here, not querySelector. Confirmed live that the app
         leaves its ORIGINAL .essential-preorder-bis-container-active wrapper behind, now EMPTY,
         as a permanent sibling inside .pdp-bis-row's placement div once relocateWishForPreorder()
         has moved its button out into .pdp-bis-row -- that's normal, healthy end-state, not a bug.
         But it means a page can have TWO+ elements matching this class at once (that harmless
         empty leftover, plus a genuinely new one the app adds while tearing down/rebuilding for a
         variant switch) -- and querySelector() only ever returns the FIRST match in DOM order,
         which (confirmed via injected-DOM testing) can be that empty leftover, making
         anyAppButtonPresent read false even while a second, later container genuinely holds a
         button. Checking every matching container (mirroring what the CSS :has(+ * .active
         button) selector already does structurally) is what makes this safety net actually fire
         in that situation instead of silently no-op'ing. */
      var activeContainers = Array.prototype.slice.call(placement.querySelectorAll('.essential-preorder-bis-container-active'));
      if(placement.classList.contains('essential-preorder-bis-container-active')){ activeContainers.push(placement); }
      var anyAppButtonPresent = activeContainers.some(function(c){ return !!c.querySelector('button'); });
      var replacementNowVisible = isVisible(bisBtn) || purchaseBtnVisible || isVisible(dupAddBtn);
      var nativeBtn = addrow.querySelector('.pdp-add');
      if(anyAppButtonPresent && !replacementNowVisible){
        if(addrow.style.display === 'none'){ addrow.style.display = ''; }
        if(nativeBtn){
          nativeBtn.style.setProperty('display', 'flex', 'important');
          nativeBtn.style.setProperty('visibility', 'visible', 'important');
          nativeBtn.setAttribute('data-yg-safety-shown', '1');
        }
      } else if(nativeBtn && nativeBtn.getAttribute('data-yg-safety-shown') === '1'){
        nativeBtn.style.removeProperty('display');
        nativeBtn.style.removeProperty('visibility');
        nativeBtn.removeAttribute('data-yg-safety-shown');
      }
    });
  }
  relocateWishForPreorder();
  document.querySelectorAll('.pdp-form').forEach(function(form){
    new MutationObserver(function(){ relocateWishForPreorder(form); }).observe(form, { childList: true, subtree: true });
    /* Bug #213: also re-run relocation on every variant-affecting user interaction (size chip
       click, native <select>/radio variant change) on a few staggered delays. The Preorder app's
       DOM takeover after a variant switch is async and doesn't always land in one clean,
       observer-catchable batch -- it can tear down the old button and build the new one across
       several ticks -- so relying solely on the MutationObserver risks re-checking mid-teardown.
       The safety-net block inside relocateWishForPreorder() above is what actually prevents a
       blank state either way; these extra calls just make sure we check again soon after user
       interaction too, not only on raw DOM mutations. */
    ['click', 'change'].forEach(function(evt){
      form.addEventListener(evt, function(){
        [0, 150, 400, 900].forEach(function(ms){ setTimeout(function(){ relocateWishForPreorder(form); }, ms); });
      }, true);
    });
  });
})();
